import * as CONST from '../../../constants';

const INITIAL_STATE = { loading: true, data: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.CLIENT_INTERCOM_NOTIFICATION_CREATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, data: null, error: null };
    case CONST.CLIENT_INTERCOM_NOTIFICATION_CREATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, data: action.data, error: null };
    case CONST.CLIENT_INTERCOM_NOTIFICATION_CREATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, data: null };
    default:
      return state;
  }
};
